import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Overview',
      href: '/en/Indoor_Cameras/IN-8401_WQHD/',
    },
    {
      text: 'Specifications',
      href: '/en/Indoor_Cameras/IN-8401_WQHD/Technical_Specifications/',
    },
    {
      text: 'Features',
      href: '/en/Indoor_Cameras/IN-8401_WQHD/Product_Features/',
    },
    {
      text: 'Installation',
      href: '/en/Indoor_Cameras/IN-8401_WQHD/Quick_Installation/',
    },
    {
      text: 'Lense Adjustment',
      href: '/en/Indoor_Cameras/IN-8401_WQHD/Lense_Adjustment/',
    },
    {
      text: 'Usermanual',
      href: '/en/Indoor_Cameras/IN-8401_WQHD/Usermanual/',
    },
    {
      text: '◄ Indoor Cameras',
      href: '/en/Indoor_Cameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-8401 2k+ WQHD Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}